<template>
  <div class="pratos-container" :class="{'visible':visible}">
    <div class="pt-header">
      <span v-text="$t('required_restriction')"></span>
      <span v-text="$t('subtitle_monday')"></span>
      <span v-text="$t('subtitle_tuesday')"></span>
      <span v-text="$t('subtitle_wednesday')"></span>
      <span v-text="$t('subtitle_thursday')"></span>
      <span v-text="$t('subtitle_friday')"></span>
      <span v-text="$t('subtitle_saturday')"></span>
      <span v-text="$t('subtitle_sunday')"></span>
      <span v-text="$t('subtitle_first_week')"></span>
      <span v-text="$t('subtitle_second_week')"></span>
      <span v-text="$t('subtitle_third_week')"></span>
      <span v-text="$t('subtitle_fourth_week')"></span>
      <span v-text="$t('subtitle_last_week')"></span>
      <span v-text="$t('subtitle_holiday')"></span>
    </div>    
    <div class="pt-body">
      <div class="pratos" v-if="grupo">
        <span v-text="grupo.nm_grupo"></span>
        <span v-text="getUtilSymbol(grupo.id_segunda)"></span>
        <span v-text="getUtilSymbol(grupo.id_terca)"></span>
        <span v-text="getUtilSymbol(grupo.id_quarta)"></span>
        <span v-text="getUtilSymbol(grupo.id_quinta)"></span>
        <span v-text="getUtilSymbol(grupo.id_sexta)"></span>
        <span v-text="getUtilSymbol(grupo.id_sabado)"></span>
        <span v-text="getUtilSymbol(grupo.id_domingo)"></span>
        <span v-text="getUtilSymbol(grupo.id_semana_1)"></span>
        <span v-text="getUtilSymbol(grupo.id_semana_2)"></span>
        <span v-text="getUtilSymbol(grupo.id_semana_3)"></span>
        <span v-text="getUtilSymbol(grupo.id_semana_4)"></span>
        <span v-text="getUtilSymbol(grupo.id_utl_semana)"></span>
        <span v-text="getUtilSymbol(grupo.id_feriado)"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnalResultPrato",
  props: ["grupo", "visible"],
  data() {
    return {};
  },
  methods: {
    getUtilSymbol: function(ut){
      if (!ut) return " ";
      const normalizedValue = String(ut).toUpperCase();
      if (normalizedValue === 'O') return "✔";
      if (normalizedValue === 'R') return "Ø";
      if (normalizedValue === 'P') return " ";
      return " ";
    }
  },
  watch: {
    visible: function() {
      this.visible;
    }
  }
};
</script>

<style scoped lang="less">
@import (reference) url("../../assets/variables.less");
@size: calc((100% - 47%) / 13);
.pratos-container {
  .sombra;
  border-radius: 12px;
  border: 1px solid rgba(33, 33, 70, 0.12);
  overflow: hidden;
  background: #fff;
}
.pt-header {
  background: linear-gradient(160deg, #24244f 0%, #1e2c6c 100%);
  color: #fff;
  display: grid;
  position: sticky;
  top: 0;
  z-index: 1;
  box-shadow: 0 2px 8px rgba(19, 24, 41, 0.2);
  
  grid-template-columns:
    47% @size @size @size
    @size @size @size @size
    @size @size @size @size @size @size;
    span{
      padding: 8px 0;
      font-size: 0.68rem;
      font-weight: 600;
      letter-spacing: 0.01em;
    }
  span:first-of-type {
    padding-left: 8px;
  }
  span:not(:first-of-type) {
    text-align: center;
  }
}
.pt-body {
  max-height: calc(100vh - 220px);
  overflow: auto;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(70, 83, 124, 0.45);
    border-radius: 999px;
  }

  .pratos {
    cursor: default;
    &:nth-of-type(2n) {
      background: rgba(242, 245, 252, 0.9);
    }
    display: grid;
    grid-template-columns:
      47% @size @size @size
    @size @size @size @size
    @size @size @size @size @size @size;
    border-bottom: 1px solid rgba(33, 33, 70, 0.08);
    transition: background-color 0.14s ease;

    &:hover {
      background: rgba(220, 232, 252, 0.55);
    }

    span{
      padding: 7px 0;
      font-size: 13px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: #212146;
    }
    span:first-of-type {
      padding-left: 8px;
      font-weight: 600;
      color: #1f2747;
    }
    span:not(:first-of-type) {
      text-align: center;
    }
  }
}
</style>
